import {AuthenticationProvider} from "@/modules/shared/bridges/AuthenticationProvider";
import {LicensingRepository} from "@/modules/licensing/adapter/LicensingRepository";
import {License} from "@/modules/licensing";
import {ServiceClient} from "@/modules/shared/ServiceCall";


export class LicensingRestRepository implements LicensingRepository {

    private readonly service: ServiceClient;

    constructor(params: {
        auth: AuthenticationProvider,
    }) {
        this.service = new ServiceClient(params.auth, 'Authentication');
    }

    public async getLicenseInfo(): Promise<License> {
        // ohne SID: /About ist auch ohne Anmeldung erreichbar
        return this.service.call<License>('getLicenceInformation', {}, { withSid: false });
    }

}
